import { render, staticRenderFns } from "./ParticipantAdversary.vue?vue&type=template&id=13caa5c6"
import script from "./ParticipantAdversary.vue?vue&type=script&lang=js"
export * from "./ParticipantAdversary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports